
// --- Code generated by protoc-gen-rg. DO NOT EDIT. --- //
import * as t from 'runtypes';
import { left, right, Either } from "fp-ts/lib/Either";
import {
  FetcherContext,
  Error as APIErrorResponse,
} from '@rogu/fetch/dist/base';
import fetcher from '@/shared/fetcher';
import { ADT } from '@rogu/adt';






export type DecodeError = t.ValidationError;

export type { APIErrorResponse };

export type ErrorResponse = DecodeError | APIErrorResponse | Error | undefined;

	export const LoginTypeSchema = t.Union(
      t.Literal("unknownLoginType"),
      t.Literal("facebook"),
      t.Literal("google"),
      t.Literal("default"),
      t.Literal("apple"),
      t.Literal("passwordless"),
      t.Literal("whatsapp"),
  );

  export type LoginType = t.Static<typeof LoginTypeSchema>;

	export const RoleValidationTypeSchema = t.Union(
      t.Literal("unknownkRoleValidation"),
      t.Literal("requestRole"),
      t.Literal("databaseRole"),
  );

  export type RoleValidationType = t.Static<typeof RoleValidationTypeSchema>;

	export const UserRoleSchema = t.Union(
      t.Literal("unknownUserRole"),
      t.Literal("teacher"),
      t.Literal("student"),
      t.Literal("admin"),
      t.Literal("parent"),
      t.Literal("employee"),
      t.Literal("company"),
      t.Literal("department"),
      t.Literal("skillAcademyUser"),
      t.Literal("instructor"),
      t.Literal("unclaimed"),
  );

  export type UserRole = t.Static<typeof UserRoleSchema>;
  
  
  
  
  
  
	export const GetOneTimeTokenResponseSchema = t.Record({
				oneTimeToken:
				t.String
				,
		})

	export type GetOneTimeTokenResponse = t.Static<typeof GetOneTimeTokenResponseSchema>;
  
	
		
		
		
		

		export type GetOneTimeTokenError = ADT<{
			DECODE_ERROR: { message: string };
			UNKNOWN_ERROR: { error?: ErrorResponse };
			SERVER_ERROR: { error: APIErrorResponse };
		}>;

		export function getOneTimeTokenExn (
			
			context?: FetcherContext,
		) {
			
				
					const ResponseSchema = GetOneTimeTokenResponseSchema;
				
			
			return new Promise<t.Static<typeof ResponseSchema>>((resolve, reject) => 
				fetcher<t.Static<typeof ResponseSchema>>({
					...context,
					url: `/api/v3/auth/one-time-token`,
					method: "get",
					withAuth:  true ,
					
					
				}).then(data => {
					// @ts-ignore
					if (!context?.disableTypeValidator) {
						
							return ResponseSchema.check(data);
						
					} else {
						return data;
					}
				}).then((dataOk) => {
					resolve(dataOk);
				})
				.catch(error => {
					if (error instanceof t.ValidationError) {
						return reject({_tag: 'DECODE_ERROR', message: error.message});
					} else if (error && 'errorCode' in error) {
						switch (error.errorCode) {
								default:
									return reject({
										_tag: 'SERVER_ERROR',
										error,
									});
						}
					}
					return reject({_tag: 'UNKNOWN_ERROR', error});
				})
			);
		}

		export function getOneTimeToken (
			
			context?: FetcherContext,
		) {
			
				
					const ResponseSchema = GetOneTimeTokenResponseSchema;
				
			
			return new Promise<
				Either<
					GetOneTimeTokenError, 
					t.Static<typeof ResponseSchema>
				>
			>((resolve) => 
				fetcher<t.Static<typeof ResponseSchema>>({
					...context,
					url: `/api/v3/auth/one-time-token`,
					method: "get",
					withAuth:  true ,
					
					
				}).then(data => {
					// @ts-ignore
					if (!context?.disableTypeValidator) {
						
							return ResponseSchema.check(data);
						
					} else {
						return data;
					}
				}).then(dataOk => {
					resolve(right(dataOk));
				})
				.catch(error => {
					if (error instanceof t.ValidationError) {
						return resolve(
							left({ _tag: "DECODE_ERROR", message: error.message })
						);
					} else if (error && 'errorCode' in error) {
						switch (error.errorCode) {
							default:
								return resolve(
									left({ _tag: 'SERVER_ERROR', error })
								);
						}
					}
					return resolve(
						left({ _tag: "UNKNOWN_ERROR", error })
					);
				})
			);
		}
	
	
	
